import { loginMethods } from 'config/loginTypes';

// 命名定義：https://app.clickup.com/36226806/v/dc/12hhqp-25378
export const THIRD_PARTY_PLATFORM_LABEL = {
    cyberbiz: 'CYBERBIZ',
    shopline: 'SHOPLINE',
    wish_mobile: 'WishMobile',
    accu: 'AccuHit',
    feversocial: 'feversocial',
    maac: 'MAAC',
    omnichat: 'Omnichat',
    botbonnie: 'BotBonnie',
    bebit: 'beBitTECH',
    gamania: 'Vyin AI',
    openai: 'OpenAI',
    gemini: 'Gemini'
};

export const THIRD_PARTY_PLATFORM_KEYS = {
    CYBERBIZ: 'cyberbiz',
    SHOPLINE: 'shopline',
    WISH_MOBILE: 'wish_mobile',
    ACCU: 'accu',
    DEMO: 'demo',
    FEVERSOCIAL: 'feversocial',
    MAAC: 'maac',
    OMNICHAT: 'omnichat',
    BOTBONNIE: 'botbonnie',
    META_FACEBOOK: 'meta_facebook',
    LINE: 'line'
};

// Platform 轉換成 login method
export const LOGIN_METHOD_TO_THIRD_PARTY_PLATFORM = {
    [loginMethods.FACEBOOK]: THIRD_PARTY_PLATFORM_KEYS.META_FACEBOOK,
    [loginMethods.LINE]: THIRD_PARTY_PLATFORM_KEYS.LINE
};

// 方案包 > 自訂社群登入 設定影響的 key
export const CUSTOM_SOCIAL_LOGIN_KEYS = {
    [THIRD_PARTY_PLATFORM_KEYS.LINE]: [
        'lineLoginAppId',
        'lineLoginAppSecret',
        'lineLoginAppScopes',
        'lineLoginAppBotPrompt',
        'lineLoginAppLiffId'
    ],
    [THIRD_PARTY_PLATFORM_KEYS.META_FACEBOOK]: [
        'facebookLoginAppId',
        'facebookLoginAppSecret',
        'facebookLoginAppScopes',
        'facebookLoginAppFields'
    ]
};

// 是否為自訂社群登入平台
export const isCustomSocialLoginPlatform = platform => {
    return Boolean(CUSTOM_SOCIAL_LOGIN_KEYS[platform]);
};
